export default {
    AdminError: "Sorry! Something went wrong. kindly contact your administrator",
    NoRecords: "No Records Found"
}